<template>
	<div>
		<b-overlay :show="is_load" rounded="sm">
			<div class="panel-tag">
				{{__t("CATEG_TAG_PUBLISH")}}
			</div>

			<div class="form-group mt-2">
				<label class="form-label" for="advanced_name">
					{{__t("CATEG_RENAME")}}
				</label>

				<div class="input-group flex-nowrap">
					<div class="input-group-prepend">
						<span class="input-group-text">
							<i class="fal  fa-typewriter fs-xl" ></i>
						</span>
					</div>
					<input id="advanced_name" type="text" class="form-control" v-model="categ.adv_name">
				</div>
			</div>

			<div class="form-group mt-2">
				<label class="form-label" for="advanced_name">
					{{__t("CATEG_ORDERING")}}
				</label>

				<div class="input-group flex-nowrap">
					<div class="input-group-prepend">
						<span class="input-group-text">
							<i class="fal  fa-typewriter fs-xl" ></i>
						</span>
					</div>
					<input id="ctg_ordering" type="number" class="form-control" v-model="categ.ordering">
				</div>
			</div>

			<div class="form-group mt-2">
				<label class="form-label" for="organization">
					{{__t("ORGANIZATION")}}
				</label>

				<div class="" v-if="organizations.length > 0">
					<v-select v-model="active_org"
							  class="imc_reasons"
							  label="title"
							  :options="this.organizations"
							  :filterable="false"
					>
						<template slot="no-options">
							{{__t("CHOICE_ORG")}}
						</template>

						<template slot="option" slot-scope="option">
							<div class="d-center">
								<div>
									{{ option.title }}
									<span class="small badge border border-info  text-info mr-1"> {{option.provider}}</span>
								</div>
								<div>
									<small>
										{{option.uniq_id}}
									</small>

								</div>
							</div>
						</template>
					</v-select>
				</div>
			</div>


			<h5 class="frame-heading">{{__t("PUBLISHED_TTL")}}</h5>
			<div class="custom-control custom-checkbox custom-control-inline">
				<input type="checkbox" v-model="categ.published" class="custom-control-input" id="publish">
				<label class="custom-control-label" for="publish">{{__t("PUBLISHED")}}</label>
			</div>

			<div class="skeep_sync mt-5">
				<h5 class="frame-heading">{{__t("SKEEP_TTL")}}</h5>
				<div class="custom-control custom-checkbox custom-control-inline">
					<input type="checkbox" v-model="categ.skeep_sync" class="custom-control-input" id="skeep_sync">
					<label class="custom-control-label" for="skeep_sync">{{__t("SKEEP_SYNC")}}</label>
				</div>
			</div>


			<div class="providers" v-if="categ.published">
				<h5 class="frame-heading mt-4">{{__t("PUBLISHED_TTL_PROV")}}</h5>
				<div class="frame-wrap">
					<div class="custom-control custom-checkbox custom-control-inline" :key="prov.id"
						 v-for="prov in providers_services">
						<input type="checkbox" v-model="prov.is_on" class="custom-control-input" :id="prov.type">
						<label class="custom-control-label" :for="prov.type">{{prov.human_name}}</label>
					</div>
				</div>
			</div>

		</b-overlay>
	</div>
</template>

<script>
import Info_field from "../../../../sys/info_field";
import vSelect from 'vue-select'
export default {
name: "categ_settings",
	components: {Info_field,vSelect},

	props : {
		categ : {
			type : Object
		}
	},
	data() {
		return {
			is_load: false,
            organizations : [],
		}
	},

	beforeDestroy() {
		EventBus.$off('save_categ_called',this.save_categ);
	},

	created() {
		EventBus.$on("save_categ_called",this.save_categ);
        this.load_organizations();
	},

	methods : {
        async load_organizations() {
            this.organizations = [];
            await api.post('/internal/v1/catalog/organizations',{}).then(({data}) => {
                this.is_load = false;
                if (data.status === "operation_success") {
                    this.organizations = data.data;
                }
            }).catch(({response}) => {
                this.is_load = false;
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    position : "b-toaster-top-left",
                    type: "danger",
                    title: response.data.status})
            });
        },

		async save_categ() {
			this.is_load = true;
			let self = this;

			//We only save Publish and Surname
			await api.put('/internal/v1/catalog/categories/' + parseInt(this.categ.id),this.categ).then(({data}) => {
                this.is_load = false;
                if (data.status === "operation_success") {
                    EventBus.$emit('save_translation',data.data.id,'category', this.Onclose);
				}
			}).catch(({response}) => {
				EventBus.$emit("categ_error_save",response.data);
				this.is_load = false;
				EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status,position : "b-toaster-top-left"})
			});
		},

        Onclose() {
            this.is_load = false;
            EventBus.$emit("close_categ");
            EventBus.$emit("reload_categories");
        }
	},


    computed : {
        providers_services() {
            return this.categ.visible_providers;
        },

        active_org : {
            get :function () {
                let active = null;
                if(this.organizations.length > 0) {
                    if(this.categ.hasOwnProperty("restaurant_id")) {
                        this.organizations.map(item => {
                            if(parseInt(item.id) === parseInt(this.categ.restaurant_id)) {
                                active = item;
                            }
                        })
                    }
                }
                return active;
            },

            set: function (val){
                if(val != null) {
                    if (this.categ.hasOwnProperty("restaurant_id")) {
                        this.categ.restaurant_id = val.id;
                    }
                }
                else {
                    this.categ.restaurant_id = 0;
                }
            },
        },
    },


}
</script>

<style scoped>

</style>
